"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxCallGenericRestApiArgs = void 0;
var HxStringPair_1 = require("./HxStringPair");
function serializeHxCallGenericRestApiArgs(_arg) {
    var output = [];
    output.push(_arg.requestUrl);
    output.push(_arg.requestMethod);
    var requestHeadersOutput = [];
    _arg.requestHeaders.forEach(function (item) { return requestHeadersOutput.push(HxStringPair_1.serializeHxStringPair(item)); });
    output.push(requestHeadersOutput);
    output.push(new Buffer(_arg.requestBody).toString('base64'));
    output.push(_arg.commandName);
    output.push(_arg.token !== undefined);
    if (_arg.token !== undefined) {
        output.push(_arg.token.unprotect());
    }
    output.push(_arg.manualSyncModeBehavior);
    return output;
}
exports.serializeHxCallGenericRestApiArgs = serializeHxCallGenericRestApiArgs;
